import { formatPhoneNumber } from '@/utils/format/phone'

import { type FormatFn } from './Format.types'

export const PhoneFormatter: FormatFn<string> = (value) => {
  return formatPhoneNumber(value.slice(2))
}
